import requests from "./httpService";

const EmployeeLeaveService = {
     getAllEmployeeLeave: async () =>{
        return requests.get("/employee-leave/all");
     },
     getEmployeeLeaveById: async (id, body) =>{
        return requests.get(`/employee-leave/${id}`, body);
     },
     UpdateEmployeeLeaveById: async (id, body) =>{
        return requests.put(`/employee-leave/${id}`, body);
     },
     addEmployeeLeave: async (body) =>{
        return requests.post("/employee-leave/add", body);
     },
     deleteEmployeeLeaveById: async (id) =>{
        return requests.delete(`/employee-leave/${id}`);
     }
}

export default EmployeeLeaveService;